module.exports = __webpack_public_path__ + "img/nome_scarpa_2.d3168ca8.svg";